import { State } from "@store/";

export default {
    methods: {
        // Inactive users stay in the store so past assignments still show their name; a select offers them only while they are its current value
        selectable(users: State["user"]["users"], selected?: string | Array<string>) {
            const current = Array.isArray(selected) ? selected : [selected];
            return users.filter((user) => !user.data?.inactive || current.includes(user.id));
        },
    },
};
